<template>
  <div class="background-image">
    <div class="background-image__container">
      <div class="background-image__preview">
        <img class="max-w-full max-h-full" :src="thumbnailBackgroundImage" alt="background image">
      </div>
      <div class="background-image__actions">
        <aha-antd-button
          variant="text-link"
          size="sm"
          :underline="true"
          v-if="changeImage"
          @click="changeImage"
        >
          {{ textChangeImage }}
        </aha-antd-button>
        <aha-antd-button
          variant="text-link"
          size="sm"
          :underline="true"
          v-if="editImage"
          @click="editImage"
        >
          {{ textEditImage }}
        </aha-antd-button>
      </div>
    </div>
    <div class="background-image__delete">
      <aha-icon-button
        v-if="deleteImage"
        @click="deleteImage"
      >
        <aha-icon
          name="trash-new"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
      </aha-icon-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BackgroundImage',
  props: {
    thumbnailBackgroundImage: {
      type: String,
      default: '',
    },
    deleteImage: {
      type: Function,
      default: null,
    },
    changeImage: {
      type: Function,
      default: null,
    },
    editImage: {
      type: Function,
      default: null,
    },
    textChangeImage: {
      type: String,
      default: 'Change image',
    },
    textEditImage: {
      type: String,
      default: 'Edit image',
    },
  },
}
</script>

<style lang="scss" scoped>
.background-image {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #D3D7E1;
  border-radius: 8px;
  padding: 12px;

  .background-image__container {
    display: flex;
    gap: 4px;
    align-items: center;
    border-radius: 4px;
  }

  .background-image__preview {
    width: 100px;
    height: 60px;

    img {
      border-radius: 4px;
    }
  }

  .background-image__actions {
    display: flex;
    flex-direction: column;
    align-items: baseline;
  }
}
</style>
